import { useEffect } from "react";

const SUPPRESSED = ["Observable cancelled prematurely"];

export function SuppressDevOverlay(): null {
  useEffect(() => {
    if (process.env.NODE_ENV !== "development") return;

    const checkAndRemove = (overlay: HTMLIFrameElement) => {
      // il contenuto potrebbe non essere ancora scritto, osserva anche l'interno
      const tryRemove = () => {
        const text = overlay.contentDocument?.body?.innerText ?? "";
        if (SUPPRESSED.some((s) => text.includes(s))) {
          overlay.remove();
          return true;
        }
        return false;
      };

      if (tryRemove()) return;

      // se il body è ancora vuoto, aspetta che venga popolato
      const inner = new MutationObserver(() => {
        if (tryRemove()) inner.disconnect();
      });

      const doc = overlay.contentDocument;
      if (doc) inner.observe(doc, { childList: true, subtree: true });
    };

    const outer = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node instanceof HTMLIFrameElement && node.id === "webpack-dev-server-client-overlay") {
            checkAndRemove(node);
          }
        });
      });
    });

    outer.observe(document.body, { childList: true });
    // eslint-disable-next-line consistent-return
    return () => outer.disconnect();
  }, []);

  return null;
}
